export default __webpack_public_path__ + "static/media/about-hero.74426449.jpg";